import { useState } from "react";
import { Link } from "react-router-dom";
import { FlaskConical, Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const PLANS = [
  { key: "free", name: "Free" }, { key: "basic_monthly", name: "Basic" }, { key: "avanzato_monthly", name: "Avanzato" },
  { key: "pro_monthly", name: "Pro" }, { key: "business_monthly", name: "Business" }, { key: "tempo1_daily", name: "A Tempo" },
];

export const AdminTestPlanCard = () => {
  const { user, checkAuth } = useAuth();
  const [busy, setBusy] = useState(null);
  const current = user?.subscription?.status === "active" ? user.subscription.lookup_key : "free";

  const pick = async (key) => {
    setBusy(key);
    try {
      await api.post("/admin/test-plan", { lookup_key: key });
      await checkAuth();
      toast.success(key === "free" ? "Ora sei sul piano Free" : `Piano ${PLANS.find((p) => p.key === key).name} attivato sul tuo account`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="rounded-2xl mo-card p-6" data-testid="admin-test-plan">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <h3 className="font-display font-semibold text-2xl flex items-center gap-2"><FlaskConical className="h-5 w-5 text-[#5aa469]" /> Prova i piani</h3>
        <Link to="/dashboard">
          <Button variant="outline" size="sm" className="rounded-full border-gray-300 bg-white hover:bg-gray-50" data-testid="admin-open-dashboard"><ExternalLink className="h-4 w-4 mr-2" />Apri la mia dashboard ristoratore</Button>
        </Link>
      </div>
      <p className="text-sm text-gray-500 mb-4">Attiva un piano sul tuo account (senza pagamento) ed entra nella dashboard ristoratore per verificare tutte le funzioni di quel piano.</p>
      <div className="flex flex-wrap gap-2">
        {PLANS.map((p) => (
          <Button key={p.key} onClick={() => pick(p.key)} disabled={busy !== null} variant={current === p.key ? "default" : "outline"}
            className={`rounded-full ${current === p.key ? "bg-[#5aa469] hover:bg-[#4a8a56] text-white" : "border-gray-300 bg-white hover:bg-gray-50"}`} data-testid={`test-plan-${p.key}`}>
            {busy === p.key ? <Loader2 className="h-4 w-4 animate-spin" /> : p.name}
          </Button>
        ))}
      </div>
      {current !== "free" && <p className="text-xs text-[#4a8a56] mt-3" data-testid="test-plan-current">Piano attivo sul tuo account: <strong>{PLANS.find((p) => p.key === current)?.name || current}</strong> (modalità prova, nessun addebito)</p>}
    </div>
  );
};
